<template>
  <span class="design-preview" aria-hidden="true">
    <i class="dp-cover"><b class="dp-title"></b><b class="dp-chips"></b></i>
    <i class="dp-cards">
      <b v-for="card in 3" :key="card" class="dp-card"></b>
    </i>
  </span>
</template>

<script>
// The journey design's thumbnail in the ride-settings picker: a dark cover
// photo over a row of tall cards.
export default {
  name: 'JourneyPreview',
};
</script>

<style scoped>
.design-preview {
  display: flex;
  flex-direction: column;
  gap: 5px;
  height: 92px;
  padding: 6px;
  border-radius: 10px;
  background: #f4f3f0;
  overflow: hidden;
  direction: ltr;
}

.design-preview i,
.design-preview b {
  display: block;
  font-style: normal;
}

.dp-cover {
  position: relative;
  flex: 0 0 46px;
  border-radius: 6px;
  background:
    linear-gradient(0deg, rgba(8, 12, 20, 0.85), rgba(8, 12, 20, 0) 80%),
    linear-gradient(135deg, #f6b26b, #8ec5fc 60%, #3a6073);
}

.dp-title {
  position: absolute;
  left: 7px;
  bottom: 16px;
  width: 48%;
  height: 7px;
  border-radius: 2px;
  background: #fff;
}

.dp-chips {
  position: absolute;
  left: 7px;
  bottom: 6px;
  width: 30%;
  height: 5px;
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.55);
}

.dp-cards {
  display: flex;
  gap: 5px;
  flex: 1;
}

.dp-card {
  flex: 0 0 30%;
  border-radius: 5px;
  background: linear-gradient(0deg, rgba(8, 12, 20, 0.6), rgba(8, 12, 20, 0) 70%), var(--primary-background, #07a0c3);
}

.dp-card:nth-child(2) {
  background: linear-gradient(0deg, rgba(8, 12, 20, 0.6), rgba(8, 12, 20, 0) 70%), linear-gradient(135deg, #84fab0, #8fd3f4);
}

.dp-card:nth-child(3) {
  background: linear-gradient(0deg, rgba(8, 12, 20, 0.6), rgba(8, 12, 20, 0) 70%), linear-gradient(135deg, #fccb90, #d57eeb);
}
</style>
